import React from 'react';
import * as _ from 'lodash';
import Cookies from 'js-cookie';
import { COOKIE_AUTH } from '../constants/cookies';
import { GET } from '../frameworks/HttpClient';
import { URL_COMMON } from '../constants/urls';


const UserContext = React.createContext({});

export function useUserContext() {
  return React.useContext(UserContext);
}

const defaultUserData = {
	created: "",
	date_joined: "",
	email: "",
  first_name: "",
  last_name: "",
  full_name: "",
	is_active: "",
	last_login: "",
  nickname: null,
  username: "",
  groups: [],
}

const defaultFeatureData = {
  employee_feature: true,
  lab_input_stock_feature: true,
  payment_feature: true,
  multiple_pond_feature: false,
  load_imported_stock_feature: false,
  tank_lot_display_method: false
}

export default function UserSettingProvider({ children }) {
  // global state สำหรับใช้จัดการ feature ที่ขึ้นกับ user
  // component นี้ ถูกเรียกบน App.js ให้ component ล่าง ๆ เรียก useContext ได้
  // component อื่น ๆ เรียกใช้ state จาก useStoreContext
  // เช่น const { setting, setStaff, fetchStoreSetting, removeStoreSetting } = useStoreContext();
  const [user, setUser] = React.useState({
    ...defaultUserData, 
    ...JSON.parse(Cookies.get(COOKIE_AUTH.USER) ? Cookies.get(COOKIE_AUTH.USER) : null)
  })
  const [features, setFeatures] = React.useState(defaultFeatureData)

  const setUserData = async(userData) => {
    Cookies.set(COOKIE_AUTH.USER, JSON.stringify(userData), { expires: 30 })
    setUser({...defaultUserData, ...userData})
  }

  const fetchFeatures = async () => {
    try {
      const response = await GET(URL_COMMON.CONFIG)
      setFeatures({ ...defaultFeatureData, ...response.data })
    } catch(error){
      console.log(error)
    }
  }

  const removeUserData = () => {
    Cookies.remove(COOKIE_AUTH.USER)
    setUser(defaultUserData)
  }

  const onLogin = (data) => {
    Cookies.set(COOKIE_AUTH.TOKEN, _.get(data, "token", null), { expires: COOKIE_AUTH.TOKEN_EXPIRE_DAYS })
    setUserData(_.get(data, "user", {}))
  }

  const onLogout = () => {
    Cookies.remove(COOKIE_AUTH.TOKEN);
    removeUserData();
  }

  React.useEffect(() => {
    if (_.get(user, 'id', null)) {
      fetchFeatures();
    }
  }, [user])

  return (
    <UserContext.Provider value={{ user, features, onLogin, onLogout, setUserData, removeUserData }}>
      {children}
    </UserContext.Provider>
  )
}